<template>
  <div class="mc-side-bar-main">
    <div class="mc-scroll-cotar">
      <div class="mc-sidebar">
        <div class="sidebar-menu-list main-list">
          <div class="menu-item-wrap" :class="{'no-sub-list': !(item.children && item.children.length > 0)}" v-for="(item, i) in sideData" :key="i">
            <div class="menu-item menu-header" v-if="item.children && item.children.length > 0" :class="{expand:item.expand}" @click="toggleSubMenu(item)">
              <div class="menu-txt">
                <i class="menu-icon fa" :class="item[logo]"></i>
                <span>{{item[text]}}</span>
              </div>
              <i class="menu-arrow fa fa-angle-right"></i>
            </div>
            <div class="menu-item" v-else :class="{ active: txtEqual($route.path, item[href]) }">
              <router-link class="menu-txt" :to="item[href]">
                <i class="menu-icon fa" :class="item[logo]"></i>
                <span>{{item[text]}}</span>
              </router-link>
            </div>
            <template v-if="item.children && item.children.length > 0">
              <transition @enter="slideDown($event, item.children.length)" @before-leave="beforeSlideUp($event, item.children.length)" @leave="slideUp">
                <div class="sidebar-menu-list sub-list" v-show="item.expand">
                  <div class="menu-item-wrap" v-for="(el, j) in item.children" :key="j">
                    <div class="menu-item" :class="{ active: txtEqual($route.path, el[href]) }">
                      <router-link class="menu-txt" :to="el[href]">
                        <span>{{el[text]}}</span>
                      </router-link>
                    </div>
                  </div>
                </div>
              </transition>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div class="side-bar-bg"></div>
  </div>
</template>

<script>
// import $ from 'jquery'
import _ from 'underscore'
// import config from '@/components/common/config'

export default {
  props: {
    // collapsed: {
    //   type: Boolean,
    //   default() {
    //     return false
    //   }
    // },
    text: {
      type: String,
      default() {
        return 'text'
      }
    },
    href: {
      type: String,
      default() {
        return 'href'
      }
    },
    logo: {
      type: String,
      default() {
        return 'logo'
      }
    },
    isLeaf: {
      type: String,
      default() {
        return 'isLeaf'
      }
    },
    groupKey: {
      type: String,
      default() {
        return 'groupKey'
      }
    },
    // menuData: {
    //   type: Array,
    //   default() {
    //     return []
    //   }
    // },
    activeNavIdx: {
      type: Number,
      default: 0
    }
  },
  created() {
    this.initSideData()
  },
  data() {
    return {
      sideData: []
      // sidebarCollapsed: this.collapsed
    }
  },
  computed: {
    groupMenuData() {
      return _.toArray(_.groupBy(this.$store.getters.sideModuleData, this.groupKey))
    }
  },
  watch: {
    groupMenuData() {
      this.initSideData()
    },
    $route() {
      this.initSideData()
    }
  },
  methods: {
    initSideData() {
      console.log(111)
      let tmp, currentIdx
      tmp = []
      currentIdx = 0
      // var data = $.extend(true, [], this.menuData)
      this.groupMenuData.forEach((menuList, i) => {
        tmp[i] = menuList.map(item => {
          // this.$set(item, 'id', false)
          if (item[this.isLeaf]) {
            // 叶子节点
            if (this.txtEqual(item[this.href], this.$route.path)) {
              currentIdx = i
            }
          } else {
            // 非叶子节点
            let sonActive = false
            if (item.children) {
              sonActive = item.children.find(el => this.txtEqual(el[this.href], this.$route.path))
            }
            if (sonActive) {
              item.expand = true
              // this.$set(item, 'expand', true)
              currentIdx = i
            } else {
              item.expand = false
              // this.$set(item, 'expand', false)
            }
          }
          return item
        })
      })
      this.$emit('update:activeNavIdx', currentIdx)
      this.sideData = tmp[currentIdx]
    },
    txtEqual(a, b) {
      return (a ? a.toLowerCase() : a) === (b ? b.toLowerCase() : b)
    },
    // 展开收拢子菜单
    toggleSubMenu(item) {
      this.sideData.forEach(el => {
        if (el[this.href] !== item[this.href]) {
          el.expand = false
        }
      })
      item.expand = !item.expand
    },
    // 菜单展开
    slideDown(el, childrenNbr) {
      // el.style.height = 'auto'
      // el.getBoundingClientRect().height
      let height = childrenNbr * 40
      el.style.height = '0px'
      // 触发浏览器重绘
      el.offsetHeight
      this.$nextTick(() => {
        el.style.height = height + 'px'
        el.style.opacity = 1
      })
    },
    // 菜单收拢前
    beforeSlideUp(el, childrenNbr) {
      // el.style.height = 'auto'
      // let height = el.getBoundingClientRect().height
      let height = childrenNbr * 40
      el.style.height = height + 'px'
      // 触发浏览器重绘
      el.offsetHeight
    },
    // 菜单收拢
    slideUp(el) {
      el.style.opacity = 0
      el.style.height = '0px'
    }
    // // 侧栏展开收拢
    // toggleSlide() {
    //   this.sidebarCollapsed = !this.sidebarCollapsed
    // }
  }
}
</script>

<style lang="scss">
@import '~@/style/config';
</style>



// WEBPACK FOOTER //
// SideBar.vue?7776afd8